<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    var color1 = ["#2CD9D5", "#D6BA96", "#02E8F3", "#D6BA96", "#02E8F3"];
    var color2 = ["#082638", "#101431", "#082638", "#101431", "#082638"];
    const yData = [320, 3, 9, 2, 5];
    this.state.chart.setOption({
      //   tooltip: {
      //     trigger: 'axis',
      //     axisPointer: {
      //       type: 'shadow'
      //     }
      // },
      legend: {
        show: false,
        itemWidth: 10,
        itemHeight: 10,
        top: "2%",
        left: "center",
        icon: "rect",
      },
      grid: {
        show: false,
        bottom: "10%",
        left: "2%",
        right: "2%",
        containLabel: true,
      },
      xAxis: {
        data: [
          "规模养殖场",
          "省级畜牧龙头企业",
          "市级龙头企业",
          "省级生态示范场",
          "市级美丽牧场",
        ],
        axisTick: {
          show: false,
        },
        axisLabel: {
          interval: 0,
          rotate: 0,
          fontSize: 18,
          color: "#fff",
        },
      },
      yAxis: {
        type: "value",
        interval: Math.ceil(
          Math.max.apply(
            null,
            yData.filter((item) => {
              return item;
            })
          ) / 5
        ),
        max:
          Math.ceil(
            Math.max.apply(
              null,
              yData.filter((item) => {
                return item;
              })
            ) / 5
          ) * 5,
        // min:0,
        splitLine: {
          show: true,
          lineStyle: {
            color: "#2A324C",
            width: 1,
            type: "solid",
          },
        },
        axisLabel: {
          fontSize: 26,
          color: "#fff",
        },
      },
      series: {
        name: "注册资本",
        type: "bar",
        barWidth: "20%",
        itemStyle: {
          color: function (params) {
            return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: color1[params.dataIndex],
              },
              {
                offset: 1,
                color: color2[params.dataIndex],
              },
            ]);
          },
        },
        label: {
          normal: {
            show: true,
            position: "top",
            fontSize: 26,
            color: "#fff",
          },
        },
        data: yData,
      },
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
